import React, {Component} from 'react';
import { connect } from 'react-redux';
import Header from '../base/header';

class SimuladorStep2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            borradores: [
                {
                    name: 'Borrador CABA',
                    date: '06/04/2018',
                },
                {
                    name: 'Borrador Rosario',
                    date: '10/04/2018',
                },
                {
                    name: 'Borrador Ruta 40',
                    date: '22/04/2018',
                },
            ]
        }
    }

    render(){
        return (
            <div>
                <Header history={this.props.history} />
                <section className="simulador">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col s12">
                                <div className="simulador_box">
                                    <div className="simulador_box_title">
                                        <h2>Crear Nuevo</h2>
                                    </div>
                                    <div className="simulador_box_content">
                                        <div className="simulador_new-draft_next">
                                            <div className="row">
                                                <div className="col s3">
                                                    <div className="btn-container previous">
                                                        <a href="/simulador">
                                                            <img className="light" alt="" src="/static/imgs/arrow-light.svg" />
                                                            <img className="dark" alt="" src="/static/imgs/angle-right.svg" />
                                                            <span>Atrás</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col s6">
                                                    <div className="btn-container">
                                                        <a href="/simulador-02">
                                                            <span>Crear</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col s3">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(SimuladorStep2);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulador-s02.js